<template>
    <div id="changepassword">

         <v-dialog
      v-model="dialog"
      width="400"
    >
      <!--<template v-slot:activator="{ on }">
        <v-btn
          style="font-family:Poppins;font-weight:500;font-size:1.2vw"
          class="text-none"
          color="white"
          flat
          dark
          v-on="on"
        >
          ¿Olvidaste tu contraseña? 
        </v-btn>
      </template>-->

      
      <v-card style="border-radius:10px" class="pb-5">
        <v-card-actions>
          <v-spacer></v-spacer>
        <v-btn  fab flat color="#B4347E" small @click="dialog = false">
          <v-icon x-large>cancel</v-icon>
        <!--<p style="font-family:Fredoka one; font-size:2.6vw">X</p>-->
        <!--<v-icon dark x-large>close</v-icon>-->
    </v-btn>
        </v-card-actions>
        
        <v-card-title 
          class="headline white lighten-2 text-xs-center"
          primary-title
          style="color:#528AC3;font-family:Poppins!important;font-size:3vw;font-weight:500"
        >
         Genera una nueva contraseña
          
        </v-card-title>
        
        <v-layout row justify-center>
         <v-flex
          xs12
          md8
          lg10
         
        >
          <v-text-field
            :append-icon="show3 ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="show3 ? 'text' : 'password'"
            name="input-10-2"
            hint="At least 8 characters"
            style="background:#ebf1f8; border-radius:8px;"
            solo
            flat
            prepend-inner-icon="lock"
            value="wqfasds"
            class="input-group--focused pa-1"
            @click:append="show3 = !show3"
          ></v-text-field>
          <br>
          <span style="color:grey; font-size:1vw; font-family:Poppins; font-weight:500">Confirmar contraseña</span>
          <br>
          <v-text-field
            :append-icon="show4 ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="show4 ? 'text' : 'password'"
            name="input-10-2"
            hint="At least 8 characters"
            style="background:#ebf1f8; border-radius:8px;"
            solo
            flat
            prepend-inner-icon="lock"
            value="wqfasds"
            class="input-group--focused pa-1"
            @click:append="show4 = !show4"
          ></v-text-field>
        </v-flex>
        </v-layout>

        <br><br>
        <v-layout row wrap justify-center="">
        <!--<v-btn
          large
      
      color="#4ba96c"
      href="#/confirm_password"
      class="text-none"
      style="border-radius:7px; color:white; font-family:Poppins;font-weight:500; font-size:1.5vw"
    >
      Enviar
    </v-btn>-->
    
    <!-- ENVIAR -->
    
        <v-btn
          large
          style="border-radius:7px; color:white; font-family:Poppins;font-weight:500; font-size:1.5vw"
          class="text-none"
          color="#4ba96c"
        >
          Confirmar 
        </v-btn>
      
    </v-layout>
      </v-card>
      
    </v-dialog>
    </div>
</template>


<script>
export default {
    data(){
        return{
            dialog:true,
            dialog1:false,
            show3:false,
            show4:false,
            password: 'Contraseña',
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          //emailMatch: () => ('The email and password you entered don\'t match')
        }
        }
    }
}
</script>
